import * as THREE from 'three';

export function createCapsuleGroup() {
    // Create the parent group
    const capsuleGroup = new THREE.Group();

    // Cylinder geometry
    const cylinderHeight = 10;
    const capsuleRadius = 3;

    // Material
    const capsuleMaterial = new THREE.MeshStandardMaterial({
      color: '#FFFFFF',
      emissive: '#000000',
      emissiveIntensity: 1.0,
      metalness: 0.9,
      roughness: 0.05,
      transparent: true,
      opacity: 0.25,
    });

    // 1) Open-ended cylinder
    const cylinderGeometry = new THREE.CylinderGeometry(
      capsuleRadius,
      capsuleRadius,
      cylinderHeight,
      32,
      1,
      true
    );
    const cylinderMesh = new THREE.Mesh(cylinderGeometry, capsuleMaterial);
    capsuleGroup.add(cylinderMesh);

    // 2) Top hemisphere
    const topSphereGeometry = new THREE.SphereGeometry(
      capsuleRadius,
      32,
      16,
      0,
      Math.PI * 2,
      0,
      Math.PI / 2
    );
    const topSphere = new THREE.Mesh(topSphereGeometry, capsuleMaterial);
    topSphere.position.y = cylinderHeight / 2;
    capsuleGroup.add(topSphere);

    // 3) Bottom hemisphere
    const bottomSphereGeometry = new THREE.SphereGeometry(
      capsuleRadius,
      32,
      16,
      0,
      Math.PI * 2,
      Math.PI / 2,
      Math.PI / 2
    );
    const bottomSphere = new THREE.Mesh(bottomSphereGeometry, capsuleMaterial);
    bottomSphere.position.y = -cylinderHeight / 2;
    capsuleGroup.add(bottomSphere);

    // ===== Double Helix Logic =====
    const doubleHelixGroup = new THREE.Group();
    capsuleGroup.add(doubleHelixGroup);

    const helixTurns = 4;
    const helixPoints = 200;
    const helixHeight = 12;
    const helixRadius = 2;
    const totalAngle = helixTurns * 2 * Math.PI;

    function generateDigitCanvas(digit, color) {
      const size = 64;
      const cnv = document.createElement('canvas');
      cnv.width = size;
      cnv.height = size;
      const ctx = cnv.getContext('2d');
      ctx.fillStyle = 'rgba(255, 255, 255, 0)';
      ctx.fillRect(0, 0, size, size);
      ctx.fillStyle = color;
      ctx.font = 'bold 48px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(digit, size / 2, size / 2);
      return cnv;
    }

    const canvas0 = generateDigitCanvas('0', '#da0000');
    const canvas1 = generateDigitCanvas('1', '#da0000');
    const texture0 = new THREE.CanvasTexture(canvas0);
    const texture1 = new THREE.CanvasTexture(canvas1);

    const lineColorOptions = ['#424242', '#FFFFFF', '#1A237E', '#00BCD4', '#FFD700'];

    for (let i = 0; i < helixPoints; i++) {
      const t = i / (helixPoints - 1);
      const y = helixHeight * (t - 0.5);

      const angle1 = t * totalAngle;
      const x1 = helixRadius * Math.cos(angle1);
      const z1 = helixRadius * Math.sin(angle1);
      const y1 = y;

      const angle2 = angle1 + Math.PI;
      const x2 = helixRadius * Math.cos(angle2);
      const z2 = helixRadius * Math.sin(angle2);
      const y2 = y;

      const digit1 = Math.random() < 0.5 ? 0 : 1;
      const digit2 = Math.random() < 0.5 ? 0 : 1;
      const digitColor = '#da0000';

      const spriteMat1 = new THREE.SpriteMaterial({
        map: digit1 === 0 ? texture0 : texture1,
        color: digitColor,
        transparent: true,
        depthTest: false
      });
      const sprite1 = new THREE.Sprite(spriteMat1);
      sprite1.scale.set(0.8, 0.8, 0.8);
      sprite1.position.set(x1, y1, z1);
      doubleHelixGroup.add(sprite1);

      const spriteMat2 = new THREE.SpriteMaterial({
        map: digit2 === 0 ? texture0 : texture1,
        color: digitColor,
        transparent: true,
        depthTest: false
      });
      const sprite2 = new THREE.Sprite(spriteMat2);
      sprite2.scale.set(0.8, 0.8, 0.8);
      sprite2.position.set(x2, y2, z2);
      doubleHelixGroup.add(sprite2);

      const lineColor = lineColorOptions[Math.floor(Math.random() * lineColorOptions.length)];
      const rungMaterial = new THREE.LineBasicMaterial({ color: lineColor });
      const rungPoints = [ new THREE.Vector3(x1, y1, z1), new THREE.Vector3(x2, y2, z2) ];
      const rungGeo = new THREE.BufferGeometry().setFromPoints(rungPoints);
      const rungLine = new THREE.Line(rungGeo, rungMaterial);
      doubleHelixGroup.add(rungLine);
    }

    // Return the entire group.
    return capsuleGroup;
}